export default {"src":"/_next/static/media/BLOK_LOGO.00edf835.svg","height":35,"width":115,"blurWidth":0,"blurHeight":0};